import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { formatTo0Decimal, isEmpty, isEmptyArray, isNotEmpty } from '../../common/util.services';
import { getBomSale } from '../order.services';
import { getMasterDataById } from '../../master-data/masterdata.services';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import SpecsComponent from '../../master-data/specs/specs.component';
import { Stack } from '@mui/system';
import { Button, IconButton, Menu, MenuItem } from '@mui/material';
import ProductDetailComponent from '../../enquiry/enq-product/product-detail.component';
import { getEnquiryProduct } from '../../enquiry/enquiry.services';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const SaleChallan = () => {
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const rows: GridRowsProp = [];
  const params = useParams();
  const orderId = params.orderId;
  const [orderCode, setOrderCode] = useState('NA')
  const [processingData, setProcessingData] = useState(rows);
  const [specsData, setSpecsData] = useState(null);
  const [openSpecs, setOpenSpecs] = useState(false);
  const [openPrdDetail, setOpenPrdDetail] = useState(false);
  const [prdDetail, setPrdDetail] = useState(null);
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const [activeRow, setActiveRow] = useState<any>(null);
  const isMenuOpen = Boolean(menuAnchorEl);
  const columns: GridColDef[] = [
    { 
      field: 'code', headerName: 'Code', filterable: false, sortable: false, editable: false, width: 120,
      cellClassName: (params) => { return params.row.inputType },
      renderCell: (params) => { return <div className="cell-link" 
      onClick={() => { openSpecsPopup(params.row) }}>{params.row.code}</div> }
    },
    { 
      field: 'product', headerName: 'Product', filterable: false, sortable: false, editable: false, width: 280,
      renderCell: (params) => (<Stack direction="row" alignItems="center" gap={1}>
                               <Button variant="contained" color='secondary'
                                onClick={() => openPrdDetailPage(params.row.productId)}
                                sx={{ width: 20, minWidth: 20, minHeight: 20, borderRadius: '50%',  
                                      padding: 0, fontSize: '0.65rem', lineHeight: 1, height: 20 }}>
                                {params.row.productSerial}</Button>{params.row.product + ' - ' + params.row.prdDesc}</Stack>)
    },
    { field: 'outputDesc', headerName: 'Output', filterable: false, sortable: false, editable: false, width: 260 },
    { 
      field: 'outputQty', headerName: 'Output Qty', filterable: false, sortable: false, editable: false, width: 120,
      renderCell: (params: any) => isEmpty(params.row.outputQty) ? '' : formatTo0Decimal(params.row.outputQty) + ' ' + params.row.uom
    },
    { 
      field: 'receivedQty', headerName: 'Received Qty', filterable: false, sortable: false, editable: false, width: 120,
      renderCell: (params: any) => isEmpty(params.row.receivedQty) ? '' : formatTo0Decimal(params.row.receivedQty) + ' ' + params.row.uom
    },
    { 
      field: 'approvedQty', headerName: 'Approved Qty', filterable: false, sortable: false, editable: false, width: 120,
      renderCell: (params: any) => isEmpty(params.row.approvedQty) ? '' : formatTo0Decimal(params.row.approvedQty) + ' ' + params.row.uom
    },
    { 
      field: 'saleQty', headerName: 'Sale Qty', filterable: false, sortable: false, editable: false, width: 120,
      renderCell: (params: any) => isEmpty(params.row.saleQty) ? '' : formatTo0Decimal(params.row.saleQty) + ' ' + params.row.uom
    },
    { 
      field: 'challan', headerName: 'Sale Challan', filterable: false, sortable: false, editable: false, width: 150,
      renderCell: (params) => { return <div className={'NA' !== params.row.challan ? "cell-link" : '' }
      onClick={() => { openSaleChallanPage(params.row) }}> {params.row.challan}</div> }
    },
    { field: 'action', headerName: 'Action', filterable: false, sortable: false, editable: false, width: 65,
      renderCell: (params: any) => (<Stack direction="row" spacing={-1} alignItems="center"
                                      justifyContent="center" sx={{ width: '100%', height: '100%' }}>
                                      <IconButton onClick={(e) => handleMenuOpen(e, params.row)} size="small" >
                                        <MoreVertIcon fontSize='small' color='secondary'/> </IconButton>
                                    </Stack>)
    }
  ];
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isEmptyArray(rows)) {
      getBomSale(orderId, appContext,
        (response: any) => {
          setProcessingData(response.data);
          setOrderCode(isEmpty(response.data[0]) ? 'NA' : response.data[0].orderCode);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }, []);

  const openSpecsPopup = (row: any) => {
    if(isNotEmpty(row.code)) {
      getMasterDataById(row.inputId, appContext,
        (response: any) => {
          appContext.setShowLoader(false);
          setLoading(false);
          setSpecsData(response.data);
          setOpenSpecs(true);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  };

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, rowData: any) => {
    setMenuAnchorEl(event.currentTarget);
    setActiveRow(rowData);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setActiveRow(null);
  };

  function isMenuApplicable(type: any) {
    if(isNotEmpty(activeRow)) {
      if('Supplier Return' === type && 'Material' !== activeRow.type) {
        return false;
      }
    }

    return true;
  }

  const openSaleChallanPage = (row: any) => {
    if('NA' !== row.challan) {
      navigate('/order/challan/list/0', {state: {orderId: row.orderId, productId: row.productId, linkId: row.linkId}});
    }
  }

  const createIssueChallan = () => {
   activeRow.challanType = 'Sale Issue';
    navigate('/order/challan/new', {state: {pojoData: activeRow, stockModel: {}}});
  }

  const createSupplierReturnChallan = () => {
    activeRow.challanType = 'Supplier Return';
    navigate('/order/challan/new', {state: {pojoData: activeRow, stockModel: {}}});
  }

  const createSaleReturnChallan = () => {
    activeRow.challanType = 'Sale Return';
    navigate('/order/challan/new', {state: {pojoData: activeRow, stockModel: {}}});
  }

  const closeSpecs = () => {
    setOpenSpecs(false);
  }

  const closePrdDetail = () => {
    setOpenPrdDetail(false);
  }

  const openPrdDetailPage = (prdId: string) => {
    getEnquiryProduct(prdId, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setLoading(false);
        setPrdDetail(response.data);
        setOpenPrdDetail(true);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const getMainPanel = () => {
    return <>
      <IGridComponent title={''} rows={processingData} columns={columns} loading={loading} maxHeight={550} hideFooterPagination={true}
        showAddBtn={false} showApproveAction={false} showDeleteAction={false} showUpAction={false} showDownAction={false}
        getRowId={(row: any) => row.id} hideFooter={false} disableMultipleRowSelection={true}
        extraText={'Order Code: ' + orderCode} showExtraText={true} extraTextColor='blue' disableRowSelectionOnClick={true}/>
      <Menu anchorEl={menuAnchorEl} open={isMenuOpen} onClose={handleMenuClose} 
        anchorOrigin={{vertical: 'top', horizontal: 'left'}} transformOrigin={{vertical: 'top', horizontal: 'right'}}>
        <MenuItem disabled={!isMenuApplicable('Issue Challan')} 
          onClick={() => { createIssueChallan(); handleMenuClose(); }}>Sale Issue</MenuItem>
        <MenuItem disabled={!isMenuApplicable('Return Challan')}
          onClick={() => { createSaleReturnChallan(); handleMenuClose(); }}>Sale Return</MenuItem>
        <MenuItem disabled={!isMenuApplicable('Supplier Return')}
          onClick={() => { createSupplierReturnChallan(); handleMenuClose(); }}>Supplier Return</MenuItem>
      </Menu>
      <IDialogComponent onClose={closeSpecs} open={openSpecs} title='Specifications' dialogClass={'spec-panel'} 
        dialogBody={<SpecsComponent data={specsData} />} />
      <IDialogComponent onClose={closePrdDetail} open={openPrdDetail} title={'Product Details'}
        dialogBody={<ProductDetailComponent readOnly={true} data={prdDetail} close={closePrdDetail}/>} />
    </>
  }

  return <TitlePanel title='Sale Challan' panelBody={getMainPanel()} />
}

export default SaleChallan;